
import {Inject, Injectable, OnDestroy, DOCUMENT} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {cambiarTema, guardarPreferenciaTema, leerPreferenciaTema, temaInicialOscuro} from '@app/config/plantilla';

/**
 * Modo claro/oscuro de la plantilla activa. Por defecto sigue el tema del sistema;
 * cuando el usuario usa el botón, su elección queda guardada y deja de seguir al sistema.
 * El tema inicial ya lo aplica aplicarPlantilla() antes del bootstrap.
 */
@Injectable({
    providedIn: 'root'
})
export class TemaService implements OnDestroy {

    private readonly oscuroSubject = new BehaviorSubject<boolean>(temaInicialOscuro());

    readonly oscuro$ = this.oscuroSubject.asObservable();

    private readonly temaSistema: MediaQueryList = typeof window !== 'undefined'
        ? window.matchMedia?.('(prefers-color-scheme: dark)')
        : null;

    private readonly alCambiarSistema = (event: MediaQueryListEvent) => {
        if (!leerPreferenciaTema()) {
            this.aplicar(event.matches);
        }
    };

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.temaSistema?.addEventListener?.('change', this.alCambiarSistema);
    }

    get oscuro(): boolean {
        return this.oscuroSubject.value;
    }

    alternar(): void {
        const oscuro = !this.oscuro;
        guardarPreferenciaTema(oscuro ? 'oscuro' : 'claro');
        this.aplicar(oscuro);
    }

    ngOnDestroy(): void {
        this.temaSistema?.removeEventListener?.('change', this.alCambiarSistema);
    }

    private aplicar(oscuro: boolean): void {
        cambiarTema(this.document, oscuro);
        this.oscuroSubject.next(oscuro);
    }
}
